import { mapArticleData, sendUAGALayers } from '~/modules/tracking/scripts/dataLayer';

export const sendDataLayer = (article, event, position) => {
  if (!article || !event || !position) return;
  const { ga } = mapArticleData(event, 'Video Detay - Önerilen İçerikler', article, position);
  if (event === 'content_impression') {
    window.dataLayer.push({
      ecommerce: null,
    });
    window.dataLayer.push({
      event: 'view_item_list', // Sabit olarak bu değer yazılmalıdır.
      ecommerce: {
        items: [ga],
      },
    });
  } else {
    sendUAGALayers({ ga });
  }
};
